import merge from 'lodash/merge';

import baseConfig from './base';
import type { LocalConfig } from './specs';

const devprodConfig = (): LocalConfig => merge(baseConfig, {
  aviakassaV2URL: 'https://v2.aviakassa.com',
  aviakassaURL: 'https://aviakassa.com',
  apiV4URL: 'https://www.aviakassa.com/api/',
  staticURL: 'https://www.aviakassa.com/s',
  cmsURL: 'https://www.aviakassa.com/cms/',
  cabinetURL: 'https://aviakassa.com/',
  cmsAuthToken: 'NF0hK7YLPWydigAfJ',

  payment: {
    cardRecognizing: true,
    excludedPayments: ['']
  },

  metricsTracking: {
    googleAnalytics: false,
    yandexMetrics: true,
    mindboxMetrics: true,
  },

  YM_TrackingID: '7972282',
  GA_TrackingID: 'UA-24277344-1',

  app: {
    trackingEnable: true,
    aprtxEnable: true,
    intentMediaEnable: true,
    GTMEnable: true,
  },

  lkRedesign: {
    isUseOldAviakassa: true,
    aviakassaURL: 'https://aviakassa.com'
  },

  avia: {
    enableAdditionalServiceInPostBook: true,
    enableAdditionalServiceInPostSale: true,
    enablePlaceChooseInPostBook: true,
    enableExtraBaggageInPostBook: true,
    /** возможно возврата заказа для АВИА */
    orderRefund: {
      /** разрешен ли добровольный возврат */
      allowVoluntaryRefund: true,
      /** разрешен ли вынужденный возврат */
      allowForcedRefund: true,
      /** включает возможность выбора способа возврата средств (на новую карту или по реквизитам) */
      enableRefundMethodSelection: false,
    },
    /**
     * Разрешенные АК:
     * DP - ПОБЕДА
     */
    allowedCarrierCodesForPlacePick: [''],
    allowedCarrierCodesForExtraBaggage: [''],
    passengerForm: {
      document: {
        enableCombinationRussianCitizenshipAndForeignDocument: false
      }
    },
    aeroexpressEnable: false,
    insuranceEnable: true,
    additionalServiceEnable: true
  },

  rail: {
    /** включение возможности возврата заказа */
    enableOrderRefund: false,
    /** включение возможности изменение электронной регистрации */
    enableOrderErChange: false
  },

  hotel: {
    /** включение возможности возврата заказа */
    enableOrderRefund: false,
    /** включение уведомления об изменении правил отмены */
    enableCancellationRulesChanges: true
  },

  cmsPages: {
    rules: 5,
    rules_en: 6
  },

  addProvisionalHeaders: true,

  headers: {
    'Client-Host': 'v2.aviakassa.com',
  },

  navigation: {
    useRouterFor: {
      redirectToAviaResults: false,
      redirectToAviaBooking: true,
      redirectToAviaCheckout: true,
      redirectToHome: false
    },
    useOldResultIdForSearch: true
  }
});

export default devprodConfig;
